import { render } from "./SignUp.vue?vue&type=template&id=836f5bb4"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"

import exportComponent from "/data/gitlab-runner/builds/hunterretail/narrowcastingrpi/narrowcastingwebapp/narrowcasting_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__